import { ChangeDetectionStrategy, Component, output, input, computed } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { TooltipModule } from 'primeng/tooltip';
import { Tree, TreeModule, TreeNodeSelectEvent } from 'primeng/tree';
import { CheckboxModule } from 'primeng/checkbox';
import { expandNode, flattenTreeNodes } from '@unified-ui/utilities';
import { TreeNode } from 'primeng/api';

@Component({
    selector: 'unified-ui-filter-lookup',
    standalone: true,
    imports: [FormsModule, InputTextModule, TooltipModule, TreeModule, CheckboxModule],
    templateUrl: './filter-lookup.component.html',
    styleUrl: './filter-lookup.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FilterLookupComponent {
    public readonly label = input.required<string>();
    readonly values = input<TreeNode[]>([]);
    readonly selectedValues = input<TreeNode[]>([]);
    protected readonly selectedValuesChangeEmitter = output<string[]>();

    protected isAllSelected = computed(() => {
        const values = this.values();
        const selectedValues = this.selectedValues();
        if (selectedValues.length === 0) {
            return undefined;
        }
        return selectedValues.length === values.length;
    });

    protected selectInverse(): void {
        const allNodes = flattenTreeNodes(this.values());
        const inverseSelection = this._getInverseSelection(allNodes, this.selectedValues());
        this.emitSelections(inverseSelection);
    }

    private _getInverseSelection(allNodes: TreeNode[], selectedNodes: TreeNode[]): TreeNode[] {
        const selectedNodeIds = new Set(selectedNodes.map(node => node.key));
        return allNodes.filter(node => !selectedNodeIds.has(node.key));
    }

    protected setSelections(tree: Tree, selectedNode?: TreeNodeSelectEvent) {
        this.emitSelections(tree.selection);
        if (selectedNode) {
            expandNode(tree.selection);
        }
    }

    protected selectAll(value: boolean | null): void {
        let selection: TreeNode[] = [];
        switch (value) {
            case true: {
                selection = flattenTreeNodes(this.values());
                break;
            }
            default: {
                selection = [];
            }
        }
        this.emitSelections(selection);
    }

    protected emitSelections(nodes: TreeNode[]): void {
        const filteredNodeIds: string[] = nodes.filter(node => !node.children).map((node: TreeNode) => node.data);
        this.selectedValuesChangeEmitter.emit(filteredNodeIds);
    }
}
